import { z } from 'zod';

/**
 * Mandanten-Terminanfrage (Mandantensicht). Feldnamen entsprechen der
 * public-sicheren API-Antwort von
 * GET /api/legaltransaction/{idLegalTransaction}/meetingrequest.
 * Es werden bewusst KEINE internen Felder erwartet/gerendert.
 */
export const meetingRequestSchema = z
  .object({
    idLegalTransactionMeetingRequest: z.number(),
    idLegalTransaction: z.number(),
    idLegalClient: z.number().nullable().optional(),
    idMeetingType: z.number().nullable().optional(),
    RequestedStart: z.string(),
    DurationInMin: z.number().nullable().optional(),
    Status: z.union([
      z.literal(10),
      z.literal(20),
      z.literal(30),
      z.literal(40),
      z.literal(50),
      z.literal(60),
    ]),
    CounterProposalStart: z.string().nullable().optional(),
    StaffMessage: z.string().nullable().optional(),
    Created_at: z.string().nullable().optional(),
    Updated_at: z.string().nullable().optional(),
  })
  .passthrough();

export type IMeetingRequest = z.infer<typeof meetingRequestSchema>;
export type MeetingRequestStatus = IMeetingRequest['Status'];

export const meetingRequestsResponseSchema = z.object({
  requests: z.array(meetingRequestSchema),
});

export type IMeetingRequestsResponse = z.infer<
  typeof meetingRequestsResponseSchema
>;

/** Public-sicherer Standort einer Terminart (nur idLocation + Name). */
export const bookingLocationSchema = z.object({
  idLocation: z.number(),
  Name: z.string().nullable().optional(),
});

export type IBookingLocation = z.infer<typeof bookingLocationSchema>;

/** Öffentlich buchbare Terminart (aus GET .../bookingoptions). */
export const bookingOptionSchema = z
  .object({
    idMeetingType: z.number(),
    Name: z.string().nullable().optional(),
    DurationInMin: z.number().nullable().optional(),
    locations: z.array(bookingLocationSchema).optional().default([]),
    /** Buchungshorizont (Tage) der Terminart — steuert, wie weit in die
     *  Zukunft Slots angefragt werden. Fallback im Frontend: 14. */
    BookingHorizonDays: z.number().nullable().optional(),
  })
  .passthrough();

export type IBookingOption = z.infer<typeof bookingOptionSchema>;

export const bookingOptionsResponseSchema = z.object({
  meetingTypes: z.array(bookingOptionSchema),
});

export type IBookingOptionsResponse = z.infer<
  typeof bookingOptionsResponseSchema
>;

/** Fertiger freier Slot (aus GET .../freebusy). */
export const freeBusySlotSchema = z.object({
  start: z.string(),
  end: z.string(),
  durationInMin: z.number(),
});

export type IFreeBusySlot = z.infer<typeof freeBusySlotSchema>;

export const freeBusyResponseSchema = z.object({
  slots: z.array(freeBusySlotSchema),
});

export type IFreeBusyResponse = z.infer<typeof freeBusyResponseSchema>;

export interface ICreateMeetingRequestPayload {
  idMeetingType: number;
  requestedStart: string;
  durationInMin?: number;
  idLocation?: number;
  clientMessage?: string;
}
